import { portalExtension } from './extensions/optional';
import { captureKioskEntry, installKioskHandoffListener } from './services/kiosk-entry';

installKioskHandoffListener();
captureKioskEntry();

async function start(): Promise<void> {
  await portalExtension.prepare();
  captureKioskEntry();
  const { bootstrap } = await import('./bootstrap');
  await bootstrap(portalExtension);
}

start().catch(error => {
  throw error;
});
